import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

import'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../config/config.service';
import { Product } from '../products/product';
import { ProductsService } from '../products/products.service';
import { ProductImageService } from '../products/product-image.service';
import { ProductImage } from '../products/product-image';
import { CartService } from '../cart/cart.service';
import { LoggingService } from '../loging/logging.service';
export class ProductDetailsComponent implements OnInit {
    product: Product;
    awsBucket: string;
    mainImageUrl: string;
    productImages: Observable<ProductImage[]>;
    selectedProductImage: ProductImage;
private config: any;
/**
 * @param {?} configService
 * @param {?} productService
 * @param {?} productImageService
 * @param {?} route
 * @param {?} location
 * @param {?} cartService
 * @param {?} loggingService
 */
constructor(
private configService: ConfigService,
private productService: ProductsService,
private productImageService: ProductImageService,
private route: ActivatedRoute,
private location: Location,
private cartService: CartService,
private loggingService: LoggingService
    ) {
        this.configService.getConfig(
            (config: any) => {
                this.config = config;

                this.awsBucket = this.config.awsBucket;
            });
    }
/**
 * @return {?}
 */
ngOnInit() {
        // this.product = { id: '1', name: 'Cell Phone', description: 'Android cell phone', price: "399.99" };
        this.loggingService.log('ProductSearchComponent:ngOnInit()');
        this.route.params.switchMap((params: Params) =>
            this.productService.getProduct(params['id']))
            .subscribe((product) => {
                this.product = product;
                this.getProductImages();
            });
    }
/**
 * @return {?}
 */
goBack(): void {
        this.location.back();
    }
/**
 * @return {?}
 */
getProductImages(): void {
        this.productImageService.getProductImages(this.product.id).subscribe(
            productImages => {
                this.productImages = productImages;
                this.selectedProductImage = this.productImages[0];
                this.mainImageUrl = this.awsBucket + this.selectedProductImage.Key;
            }
        );
    }
/**
 * @param {?} productImage
 * @return {?}
 */
onSelectImage(productImage: ProductImage): void {
        this.selectedProductImage = productImage;
        this.mainImageUrl = this.awsBucket + this.selectedProductImage.Key;
    }
/**
 * @param {?} product
 * @return {?}
 */
addToCart(product: Product): void {
        this.cartService.add(product);
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'my-product-details',
    template: "<div class=\"product-details\" *ngIf=\"product\"> <h2>{{product.name}}</h2> <img id=\"mainImage\" src=\"{{mainImageUrl}}\" class=\"img-responsive center-block\" alt=\"{{product.name}}\" align=\"middle\" /> <div class=\"product-description\">{{product.description}}</div> <div class=\"price\">${{product.price}}</div> <div class=\"product-images\" *ngIf=\"productImages\"> <img *ngFor=\"let productImage of productImages\" [class.selected]=\"productImage === selectedProductImage\" (click)=\"onSelectImage(productImage)\" id=\"image-{{productImage._id}}\" src=\"{{awsBucket + productImage.Key}}\" alt=\"product image\" style=\"height:50px;width:50px\" /> </div> <button (click)=\"goBack()\">Back</button> <button (click)=\"addToCart(product)\">Add to Cart</button> </div>",
    styles: ["label { display: inline-block; width: 3em; margin: .5em 0; color: #607D8B; font-weight: bold; } input { height: 2em; font-size: 1em; padding-left: .4em; } button { margin-top: 20px; font-family: Arial; background-color: #eee; border: none; padding: 5px 10px; border-radius: 4px; cursor: pointer; cursor: hand; } button:hover { background-color: #cfd8dc; } button:disabled { background-color: #eee; color: #ccc; cursor: auto; } .input-div { width: 100%; } .input-div input { width: 100%; } .input-div textarea { width: 100%; } .product-details { overflow: auto; width: 100%; } .product-details div { width: 100%; } .selected{ border:double; border-width:thick; } .product-images{ list-style-type:none; }"]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ConfigService, },
{type: ProductsService, },
{type: ProductImageService, },
{type: ActivatedRoute, },
{type: Location, },
{type: CartService, },
{type: LoggingService, },
];
}

function ProductDetailsComponent_tsickle_Closure_declarations() {
/** @type {?} */
ProductDetailsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProductDetailsComponent.ctorParameters;
/** @type {?} */
ProductDetailsComponent.prototype.product;
/** @type {?} */
ProductDetailsComponent.prototype.awsBucket;
/** @type {?} */
ProductDetailsComponent.prototype.mainImageUrl;
/** @type {?} */
ProductDetailsComponent.prototype.productImages;
/** @type {?} */
ProductDetailsComponent.prototype.selectedProductImage;
/** @type {?} */
ProductDetailsComponent.prototype.config;
/** @type {?} */
ProductDetailsComponent.prototype.configService;
/** @type {?} */
ProductDetailsComponent.prototype.productService;
/** @type {?} */
ProductDetailsComponent.prototype.productImageService;
/** @type {?} */
ProductDetailsComponent.prototype.route;
/** @type {?} */
ProductDetailsComponent.prototype.location;
/** @type {?} */
ProductDetailsComponent.prototype.cartService;
/** @type {?} */
ProductDetailsComponent.prototype.loggingService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
